import { render, staticRenderFns } from "./newTab.vue?vue&type=template&id=0c2e04aa&scoped=true"
import script from "./newTab.vue?vue&type=script&lang=js"
export * from "./newTab.vue?vue&type=script&lang=js"
import style0 from "./newTab.vue?vue&type=style&index=0&id=0c2e04aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e04aa",
  null
  
)

export default component.exports